import React from 'react';
import * as Household from './household.js';

import * as View from './view.js';
import * as $ from 'jquery';

var items = {
    resetFormNew: function() {
        $("#add_item_name").val("")
        $("#add_item_name").parent().removeClass("is-dirty")

        $("#add_item_description").val("")
        $("#add_item_description").parent().removeClass("is-dirty")

        $("#add_item_price").val("")
        $("#add_item_price").parent().removeClass("is-dirty")

    },
    submitFormNew: function() {
        var auth = JSON.parse(localStorage.getItem("auth"))

        var form = {
            username: auth.username,
            password: auth.password,
            item: {
                name: $("#add_item_name").val(),
                description: $("#add_item_description").val(),
                price: $("#add_item_price").val(),
            }
        }

        var superform = {
            data: JSON.stringify(form)
        }


        $.ajax("https://api.antipy.com:1550/invoice/items/add", {
            method: "post",
            data: superform,
            dataType: "json",
            success: function (dataIn) {
                var data = dataIn
        
                if (data.success) {
                    Household.showSnack("Added Item")
                    View.State("itemList")
                }
            },
            error: function (dataIn) {
                var data = dataIn.responseJSON
            
                if (!data.success) {
                    Household.showSnack(data.message)
                }    
            },
        })
    }
}

export class List extends React.Component {
    render() {
        return (
            <div>
                <h1>Items</h1>
                <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
                    <thead>
                        <tr>
                            <th class="mdl-data-table__cell--non-numeric">Name</th>
                            <th>Price per Item</th>
                            <th class="mdl-data-table__cell--non-numeric"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ListItem name="Basic Website Buidling" price="€29.99" id="a9P5eDx1"/>
                        <ListItem name="Service and Maintainace (Monthly)" price="€5.99" id="zu8pD458"/>
                        <ListItem name="Dynamic Server Hosting (Monthly)" price="€10.99" id="r5QP6m44"/>
                        <tr>
                            <td class="mdl-data-table__cell--non-numeric"></td>
                            <td class="mdl-data-table__cell--non-numeric"></td>
                            <td><button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" onClick={() => View.State("itemAdd")}><i class="material-icons">add</i></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export class Add extends React.Component {
    render() {
        return (
            <div>
                <h1>Items</h1>
                <div class="demo-card-wide mdl-shadow--2dp" style={{width: "400px"}}>
                    <div class="mdl-card__supporting-text">
                        <h4>Add Items</h4>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_item_name"/>
                            <label class="mdl-textfield__label" for="add_item_name">Name...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_item_description"/>
                            <label class="mdl-textfield__label" for="add_item_description">Description...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="number" min="0.00" step="0.01" id="add_item_price"/>
                            <label class="mdl-textfield__label" for="add_item_price">Price per Item (€)...</label>
                            <span class="mdl-textfield__error">Input can not be negative or have more than 2 decimal places!</span>
                        </div><br/><br/><br/>
                        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect" onClick={() => items.resetFormNew()}>Reset</button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect" onClick={() => items.submitFormNew()}>Add</button>
                    </div>
                </div>
            </div>
        );
    }
}

export class Edit extends React.Component {
    render() {
        return (
            <div>
                <h1>Customers</h1>
                
            </div>
        );
    }
}

class ListItem extends React.Component {
    render() {
        return (
            <tr>
                <td class="mdl-data-table__cell--non-numeric">{this.props.name}</td>
                <td>{this.props.price}</td>
                <td><button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" onClick={() => console.log(this.props.id)}><i class="material-icons">edit</i></button></td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/item.js